module.exports = __webpack_public_path__ + "img/dingdanshuliang.fbe44407.png";